import { CustomEventName } from '../utils/tracking'
import { PackId } from '../utils/offerBus'

export type ObjectionId = 'battery' | 'visibility' | 'fogging' | 'lenses' | 'durability' | 'price'

export interface ObjectionChoice {
  id: ObjectionId
  label: string
  sub?: string
  event: CustomEventName
  viewEvent: CustomEventName
  /** Pack recommended inside this personalized funnel. */
  recommend: PackId
}

/**
 * One personalized recovery funnel per objection. They all live in a single
 * hidden area low on the page: only the one the visitor picked is revealed, so
 * normal browsing never sees six extra funnels.
 */
export const objectionChoices: ObjectionChoice[] = [
  {
    id: 'battery',
    label: 'Battery / full shift',
    event: 'objection_battery_selected',
    viewEvent: 'mini_funnel_battery_viewed',
    recommend: 'trio',
  },
  {
    id: 'visibility',
    label: 'Brightness / visibility',
    event: 'objection_visibility_selected',
    viewEvent: 'mini_funnel_visibility_viewed',
    recommend: 'trio',
  },
  {
    id: 'fogging',
    label: 'Fogging / anti-fog',
    event: 'objection_antifog_selected',
    viewEvent: 'mini_funnel_antifog_viewed',
    recommend: 'trio',
  },
  {
    id: 'lenses',
    label: 'Lens options',
    event: 'objection_lenses_selected',
    viewEvent: 'mini_funnel_lenses_viewed',
    recommend: 'trio',
  },
  {
    id: 'durability',
    label: 'Durability / warranty',
    event: 'objection_durability_selected',
    viewEvent: 'mini_funnel_durability_viewed',
    recommend: 'trio',
  },
  {
    id: 'price',
    label: 'Price',
    sub: "I don't want to spend that much",
    event: 'objection_price_selected',
    viewEvent: 'mini_funnel_price_viewed',
    recommend: 'trio',
  },
]

export const objectionModal = {
  headline: 'Still deciding?',
  subheadline: "What's holding you back?",
  support: "Tell us what matters most. We'll show you the answer.",
  wantIt: {
    label: 'None of these. I want it.',
    sub: 'Take 5% off and go straight to the packs.',
    badge: '5% off',
  },
}

/** Anchor for the single recovery area. */
export const RECOVERY_ID = 'objection-recovery'
